<template>
  <div class="avatar" :style="avatarStyle">
    <span>{{ initial }}</span>
  </div>
</template>

<script>
export default {
  name: "CircleAvatar",
  props: {
    attendee: {
      type: Object,
      required: true,
    },
    radius: {
      type: Number,
      default: 32,
    },
  },
  computed: {
    name() {
      return (
        this.attendee.displayName ||
        this.attendee.name ||
        this.attendee.email ||
        ""
      );
    },
    initial() {
      if (!this.name.trim()) return "";
      return this.name.trim()[0].toUpperCase();
    },
    bgColor() {
      return this.getAvatarColor(this.name);
    },
    avatarStyle() {
      const size = `${this.radius * 2}px`;
      return {
        width: size,
        height: size,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 500,
        fontSize: `${this.radius - 1}px`,
        lineHeight: `${this.radius - 1}px`,
        color: "white",
        backgroundColor: this.bgColor,
        flexShrink: 0,
      };
    },
  },
  methods: {
    getAvatarColor(identifier) {
      const colors = [
        "#2D6BC7",
        "#00B9CC",
        "#00BB5F",
        "#8FBB02",
        "#C9293F",
        "#CC5700",
        "#D4AA02",
        "#6441C9",
        "#FF69B4",
        "#19B99A",
        "#8B7169",
        "#667883",
      ];
      if (!identifier) return colors[0];
      const match = identifier.match(/(?:spk|speaker)(\d+)/i);
      if (match) {
        const num = parseInt(match[1], 10) || 0;
        return colors[num % colors.length];
      }
      let hash = 0;
      for (let i = 0; i < identifier.length; i++) {
        hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },
  },
};
</script>

<style scoped>
.avatar {
  text-transform: uppercase;
  user-select: none;
}
</style>
